import {createFetchListReducer} from 'common/reducers/utils';

const defaultReducer = createFetchListReducer({
  name: 'service',
  keys: ['agencyId'],
});

export default function service(state = {
  isFetching: false,
  items: {},
}, action) {
  return defaultReducer(state, action);
}



// WEBPACK FOOTER //
// ./src/ondemand/reducers/service.js